import { getPulseTracker } from '@schibsted/pulse-sdk';
import type { Tracker, Builders, SDKConfigInput } from '@schibsted/pulse-sdk';

interface GlobalPulse {
    (cb: (tracker: Tracker) => void): void;
    (
        action: 'init',
        clientId: string,
        config: SDKConfigInput,
        builders?: Builders,
        name?: string,
    ): Promise<void>;
    (action: string, cb: (tracker: Tracker) => void): void;
}

declare global {
    interface Window {
        pulse?: GlobalPulse;
    }
}

let initialized = false;
let tracker: Tracker | null = null;

export const getTracker = async () => {
    if (!initialized) {
        if (window.pulse && window.pulse instanceof Function) {
            tracker = await new Promise<Tracker | null>((resolve) => {
                window.pulse!((trk) => resolve(trk));
            }).catch(() => null);
        }

        if (!tracker) {
            tracker = await getPulseTracker().catch(() => null);
        }

        if (!tracker) {
            tracker = null;
            console.warn('Pulse tracker not found');
        }

        initialized = true;
    }
    return tracker;
};
